import Content from "components/Content";
import Label from "components/Label";
import Link from "components/Link";
import React, { FC } from "react";
import { FiArrowRight as ArrowRight } from "react-icons/fi";

import { items } from "./constants";
import styles from "./styles.module.scss";

const HowItWorks: FC = () => {
  return (
    <Content contentClassName={styles.container}>
      <Label color="primary" variant="h-centered" className={styles.title}>
        Humming Homes turns to-dos into dones.
      </Label>
      <Label color="primary" variant="s-centered" className={styles.subtitle}>
        With hundreds of happy customers and reviews, your referral won’t have
        to worry about home maintenance. Here’s what they can expect!
      </Label>
      <div className={styles.items}>
        {items.map(({ Icon, text }) => (
          <div className={styles.item}>
            <Icon className={styles.icon} />
            <Label
              color="primary"
              variant="s-centered"
              className={styles.itemLabel}
            >
              {text}
            </Label>
          </div>
        ))}
      </div>
      <Link
        className={styles.link}
        variant="capitalized"
        color="accent"
        to="/services"
        label="How it works"
        Icon={<ArrowRight />}
      />
    </Content>
  );
};

export default HowItWorks;
